import api from '@pray/shared/utils/api';

import type { WorkflowVersionResponse } from './data/response';

type GetDraftVersionProps = {
  artistId: string;
  workflowId: string;
};

export async function getDraftVersion({
  artistId,
  workflowId,
}: GetDraftVersionProps): Promise<WorkflowVersionResponse> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!workflowId) throw new Error('Workflow ID is required');

  const url = `/web/studio/artists/${artistId}/workflows/${workflowId}/versions/draft`;

  const response = await api.executeGetRequest<WorkflowVersionResponse>(url);
  return response.data;
}
